module.exports = __webpack_public_path__ + "static/media/Horizon.18b0594.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vidio/Horizon.mp4
// module id = yMQG
// module chunks = 0